import type { FC } from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage, useIntl } from '@/components/formatted_message/FormattedMessage';
import { EnmonLogo } from '@/routes/auth/components/EnmonLogo';
import { Typography } from '@/components/typography';
import { useAuthContext } from '@/contexts/AuthContext';
import { Alert } from '@/components/alert';
import { RecoveryForm } from './components/Form';
import { Page as messages } from './messages';
import { Flex } from 'antd';
import { StyledAuthLayout } from '../../components/Containers';

const { Headline, Paragraph } = Typography;

export const ForgotPasswordPage: FC = () => {
  const intl = useIntl();
  const { isError: hasError, error } = useAuthContext();

  return (
    <StyledAuthLayout>
      <Helmet>
        <title>{intl.formatMessage(messages.title)}</title>
      </Helmet>
      <EnmonLogo />
      <Flex gap={24} vertical>
        <Flex gap={8} vertical>
          <Headline>
            <FormattedMessage {...messages.title} />
          </Headline>
          <Paragraph>
            <FormattedMessage {...messages.hint} />
          </Paragraph>
        </Flex>
        {hasError && error.resetPassword ? (
          <Alert
            showIcon
            data-cy="forgotPassword-error"
            data-test="forgotPassword-error"
            description={<FormattedMessage {...messages.resetPasswordError} />}
            type="error"
          />
        ) : null}
        <RecoveryForm />
      </Flex>
    </StyledAuthLayout>
  );
};
